<script setup>
  import { ref, onMounted, watch, watchEffect} from 'vue';
  import BaseModal from './base/BaseModal.vue';
  import ModalContentTextInput from '@/components/ModalContentTextInput.vue';
  
  const emits = defineEmits(['close']);

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    },
  });


  const showModal = ref(false);

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  })

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="true"
    @close="closeModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Spot Forecast Help</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <div class="jwx-modal__section-header">
          <h4 class="jwx-modal__section-title">What does the forecast table represent?</h4>
        </div>
        <div class="jwx-modal__section-body">
          <p class="jwx-modal__text">
            The forecast table represents a range of sustained average wind speeds and direction at a specified location.
          </p>
        </div>
      </div>
    </div>         
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          Close
      </button>
      </div>
    </div>
  </BaseModal>
</template>